const SESSION_CACHE_KEY =
  typeof window !== 'undefined'
    ? (window as any).__DIRECTUS_CACHE_KEY ||
      ((window as any).__DIRECTUS_CACHE_KEY = Date.now())
    : Date.now()

export function directusFileUrl(fileId: string): string {
  if (!fileId) return ''
  const hasQuery = fileId.includes('?')
  return `https://mamf-www-directus.moveapp.org/assets/${fileId}${hasQuery ? '&' : '?'}v=${SESSION_CACHE_KEY}`
}

export function directusDownloadUrl(fileId: string): string {
  return `${directusFileUrl(fileId)}&download`
}
